import React, { useState, useEffect } from "react";
import styles from "../css/styles.module.css";
import AddContact from "./addContact";
import EditContact from "./editContact";
import SearchBar from "./searchBar";
import { db } from "../config/firebase";
import trash from "../images/delete.png";

export default function Contact(props) {
  const [data, setData] = useState(null);
  const [add, setAdd] = useState(false);
  const [remove, setRemove] = useState(false);
  const [edit, setEdit] = useState(false);
  const [chosenContact, setChosenContact] = useState(null);

  useEffect(() => {
    setData(props.data);
  }, [props.data]);

  //handling add button click which will display add form
  function handleAddClick() {
    setAdd(true);
  }

  //handle the edit button being click by displaying the edit form
  function handleEditClick(contact) {
    setChosenContact(contact);
    setEdit(true);
  }

  //handling delete button click which will display the delete button on each row in the table
  function handleDeleteStartClick() {
    setRemove(!remove);
  }

  //handling trash icon click which will delete the data of that row from firestore
  function handleDeleteClick(key) {
    db.collection("contacts").doc(key).delete();
  }

  //handling adding new data to firestore
  function handleAddSubmit(newContact) {
    setAdd(false);
    db.collection("contacts")
      .add(newContact)
      .catch((err) => {
        console.log(err);
      });
  }

  //handle edit form submit by updating the chosen contact's record
  function handleEditSubmit(e, contact) {
    e.preventDefault();
    setEdit(false);
    db.collection("contacts")
      .doc(chosenContact.id)
      .set(contact)
      .catch((err) => {
        console.log(err);
      });
  }

  //handling user clicking cancel at the add form
  function handleCancelClick() {
    setAdd(false);
    setEdit(false);
  }

  //handling user changing input in search bar
  function handleSelectChange(selected) {
    //if selected input matches the customer value then only show match value
    if (selected) {
      setData(
        props.data.filter((d) => {
          return d.data.customer === selected.value;
        })
      );
    } else {
      //else display all the data
      setData(props.data);
    }
  }

  //if add button is clicked, show the add data form
  if (add) {
    return (
      <div className={styles.addContainer}>
        <AddContact
          handleAddSubmit={handleAddSubmit}
          handleCancelClick={handleCancelClick}
          customer={props.customer}
        />
      </div>
    );
  } else if (edit) {
    return (
      <div className={styles.addContainer}>
        <EditContact
          handleEditSubmit={handleEditSubmit}
          handleCancelClick={handleCancelClick}
          contact={chosenContact}
          customer={props.customer}
        />
      </div>
    );
  } else {
    //else show the data table
    return (
      <div className={styles.subContent}>
        <div className={styles.contentHeaderContainer}>
          <h1>Contact</h1>
          <SearchBar
            options={props.search}
            placeholder="Search by customer..."
            errorMessage="No contact with that name"
            handleSelectChange={handleSelectChange}
            isClearable={true}
          />
          <div className={styles.buttonContainer}>
            <button onClick={handleAddClick} className={styles.addButton}>
              Add +
            </button>
            <button
              onClick={handleDeleteStartClick}
              className={styles.deleteButton}
            >
              {remove ? "Cancel" : "Delete -"}
            </button>
          </div>
        </div>
        <div className={styles.tableContainer}>
          <table>
            <thead>
              <tr>
                <td>Name</td>
                <td>Customer</td>
                <td>Email</td>
                <td>Phone Number</td>
                <td>Position</td>
                <td className={styles.small}></td>
                {remove && <td className={styles.small}></td>}
              </tr>
            </thead>
            <tbody>
              {data &&
                data.map((contact) => {
                  return (
                    <tr key={contact.id}>
                      <td>{contact.data.name}</td>
                      <td>{contact.data.customer}</td>
                      <td>{contact.data.email}</td>
                      <td>{contact.data.phone}</td>
                      <td>{contact.data.position}</td>
                      <td className={styles.editButton} onClick={() => handleEditClick(contact)}>Edit</td>
                      {remove && (
                        <td
                          className={styles.trashButton}
                          onClick={() => handleDeleteClick(contact.id)}
                        >
                          <img src={trash} alt="Delete" />
                        </td>
                      )}
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}
